import React, { useEffect, useState } from 'react';

/**
 * idefix · Glowy Studio çerçeve üretimi teklifi (Yataş Grubu teklifinin uyarlaması).
 * Route: /r/idefix-studio-teklif (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 6 slayt, 16:9, tek marka.
 *
 * Yeniden üretmek için:
 *   node src/pages/idefix-studio-teklif/build.js && node src/pages/idefix-studio-teklif/pdf.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma. iframe'e sandbox EKLEME, indirme kırılır.
 *
 * HTML modülü ~50KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
const YUKLE = () => import('./idefixStudioTeklifHtml');

export default function IdefixStudioTeklif() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    YUKLE()
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return <iframe title="idefix · Glowy Studio Çerçeve Teklifi" srcDoc={html} style={fill} />;
}
